import React, { useState, useEffect } from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

const NetworkStatus = () => {
  // eslint-disable-next-line no-unused-vars
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [open, setOpen] = useState(!navigator.onLine)
  const [openBackOnline, setOpenBackOnline] = useState(!navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setOpen(false)
      setOpenBackOnline(true)
    }

    const handleOffline = () => {
      setIsOnline(false)
      setOpenBackOnline(false)
      setOpen(true)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Cleanup the event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (isOnline) {
    return (
        <Snackbar open={openBackOnline} autoHideDuration={1000} onClose={() => setOpenBackOnline(false)}>
            <Alert severity="success" onClose={() => setOpenBackOnline(false)}>
                You are back online.
            </Alert>
        </Snackbar>
    )
  }

  return (
    <Snackbar open={open}>
      <Alert severity="error" onClose={() => setOpen(false)}>
        You are currently offline. Please check your Internet connection.
      </Alert>
    </Snackbar>
  )
}

export default NetworkStatus
